<template>
  <div class="subscribe">
    <img src="https://summit-img.geekpark.net/07-%E9%82%AE%E4%BB%B6%E8%AE%A2%E9%98%85-%E8%8B%B1%E6%96%87.svg"
         style="width: 83%">
    <div class="bottom">
      <img src="https://summit-img.geekpark.net/07-%E9%82%AE%E4%BB%B6%E8%AE%A2%E9%98%85-StayTuned.svg"
           style="width: 30%">
      <p>
        订阅 IF X 邮件会刊，第一时间获取嘉宾动态、日程更新、票务活动等资讯 。
      </p>
      <form @submit.prevent="subscribe">
        <input type="email" required placeholder="填写您的E-mail地址" v-model="email">
        <button>订阅 ></button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Subscribe',
  data () {
    return {
      email: ''
    }
  },
  methods: {
    subscribe () {
      axios.post('https://events.geekpark.net/api/v1/involvers', {
        email: this.email,
        content_type: 'IFX',
        activity_id: 'f17e2e76-b88b-42e9-a311-48897ae5ba8a'
      }).then(res => {
        alert(`邮箱 ${this.email} 已订阅成功`)
        this.email = ''
      }).catch((error) => {
        if (error.response.status === 422) {
          alert(`邮箱 ${this.email} 已经订阅过了~`)
        } else {
          alert('网络有点问题~')
        }
      })
      return false
    }
  }
}
</script>

<style scoped lang="less">
  .subscribe {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 70vh;
    height: 100%;
    box-sizing: border-box;
    margin-left: 14vh;
    padding: 8vh 6vh 15vh 6vh;
    background-color: #ff3c00;

    img {
      display: block;
    }
  }

  .bottom {
    > p {
      width: 90%;
      margin: 3vh 0 5vh 0;
      color: #fff;
      text-align: justify;
      font-size: 2.5vh;
      font-weight: 100;
    }
  }

  form {
    display: flex;
    justify-content: space-between;

    input {
      box-sizing: border-box;
      padding-left: 2vh;
      width: 42vh;
      height: 6vh;
      border: none;
      background: #ffffff;
      font-size: 2.5vh;
      border-radius: 0;
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 15vh;
      border: none;
      color: #fff;
      background-color: #000;
      font-size: 3vh;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
